import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  List,
  SwipeableDrawer,
  Typography,
  useTheme,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import driversidebarCover from "../../../../media/images/driversidebarCover.svg";

import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenDriverSidebar } from "../../../../redux/features/settingSlice";
import LogoSe from "../../../../media/images/icons/logoSecondary.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomListItem from "./components/ListItem";
import GuidIcon from "../../../../media/images/icons/guidIcon.svg";
import LearnVideoIcon from "../../../../media/images/icons/LearnVideoIcon.svg";
import TermsIcon from "../../../../media/images/icons/TermsIcon.svg";
import NotifIcon from "../../../../media/images/icons/NotifIcon.svg";
import HomeIcon from "../../../../media/images/icons/HomeIcon.svg";
import LoginSVG from "../../../../media/images/icons/login-newsvg";
import UserRegister from "../../../../media/images/icons/userRegister";
import CallIcon from "../../../../media/images/icons/call.svg";
import CustomAccordion from "./components/Accordion";
import PlusIcon from "../../../../media/images/icons/plus";
import Money_Report from "../../../../media/images/icons/Money_Report.png";
import BigCar_3d from "../../../../media/images/icons/bigcar-3d.png";
import ProfileImage from "../../../../media/images/profileImage.png";
import InfoAuth from "../../../../media/images/icons/auth-info.svg";
import { Link } from "react-router-dom";
import ThemeToggle from "../../../components/ThemeToggle";
import CarTagView from "../../../components/CarTag";
import UserOctagone from "../../../../media/images/icons/user-octagone";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";
import WalletEmpty from "../../../../media/images/icons/empty-wallet.svg";
import EmptyWallet from "../../../../media/images/icons/empty-wallet";

export default function DriverSidebar() {
  const { driverSidebar, themeMode } = useAppSelector((state) => state.setting);
  const dispatch = useAppDispatch();

  const theme = useTheme();

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      dispatch(setOpenDriverSidebar(false));
    };

  return (
    <Box>
      <SwipeableDrawer
        dir="rtl"
        sx={{
          "& .MuiPaper-root": {
            width: 270,
            position: "absolute",
            bgcolor: "primary.light",
            right: "0px",
            top: "0px",
            bottom: "0px",
            height: "auto",
            // borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          },
        }}
        anchor="right"
        open={driverSidebar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Box
          sx={{
            backgroundImage: `
            url(${driversidebarCover})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#0D4884",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            padding: "8px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={
                {
                  // backgroundColor: "error.main",
                }
              }
            >
              <PlusIcon />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "background.default",
                borderRadius: "4px",
                padding: "4px",
                gap: "8px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                حالت تاریک
              </Typography>
              <ThemeToggle />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              backgroundColor: "background.default",
              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "10px",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <img
                  style={{
                    borderRadius: "16px",
                  }}
                  width={40}
                  src={ProfileImage}
                  alt=""
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    رضا یعقوبی‌فریان پور
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "secondary.light",
                      borderRadius: "4px",
                      paddingX: "4px",
                      gap: "3px",
                    }}
                  >
                    <img src={InfoAuth} alt="" />
                    <Typography
                      sx={{
                        color: "secondary.main",
                        fontSize: "10px",
                      }}
                    >
                      نیازمند احراز هویت
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontFamily: "YeBakhNu",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                09121234567
              </Typography>
            </Box>

            <Box
              sx={{
                backgroundColor: "info.light",
                width: "100%",
                padding: "4px",
                borderRadius: "8px",
                marginTop: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  مسقف یا چادری خاور
                </Typography>
                <CarTagView />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  تاریخ پایان معاینه فنی:
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "YeBakhNu",
                    fontWeight: "600",
                  }}
                >
                  1402/12/05
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  تاریخ پایان معاینه فنی:
                </Typography>
                <Typography sx={{ fontFamily: "YeBakhNu", fontWeight: "600" }}>
                  1402/12/05
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              mt: 1,
            }}
          >
            <Link
              to={"/driver/profile"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.background.default,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid gray",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <UserOctagone
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>مشخصات حساب/ناوگان</Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
            <Link
              to={"/driver/wallet"}
              style={{
                padding: "8px 4px",
                backgroundColor: theme.palette.background.default,
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // border: "1px solid gray",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <EmptyWallet
                  color={
                    themeMode === "light"
                      ? theme.palette.textColor.main
                      : "#fff"
                  }
                />
                <Typography>کیف پول </Typography>
              </Box>
              <ArrowLeftCircle
                color={
                  themeMode === "light" ? theme.palette.textColor.main : "#fff"
                }
              />
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "8px",
            px: "8px",
            alignItems: "center",
          }}
        >
          <Link
            to={"/check-in"}
            style={{
              flex: "1",
              height: 32,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
              gap: "3px",
            }}
          >
            <img width={40} src={BigCar_3d} alt="" />
            <Typography
              sx={{
                whiteSpace: "nowrap",
                color: "#fff",
              }}
            >
              اعلام حضور{" "}
            </Typography>
          </Link>
          <Link
            to={"#"}
            style={{
              flex: "1",
              height: 32,
              overflow: "hidden",
              borderRadius: "8px",
              padding: "0px 0px",
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <img height={40} width={40} src={Money_Report} alt="" />
            <Typography
              sx={{
                whiteSpace: "nowrap",

                color: "#fff",
              }}
            >
              مناقصات بار
            </Typography>
          </Link>
        </Box>

        <Box
          sx={{
            paddingX: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "background.default",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <CustomListItem
                  path="/driver/notifications"
                  title="اعلان‌ها"
                  icon={GuidIcon}
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/suport"
                  title="پشتیبانی"
                  icon={LearnVideoIcon}
                />
                <Divider variant="middle" />
                <CustomListItem
                  path="/driver/communicate-companies"
                  title="ارتباط با شرکت‌ها"
                  icon={TermsIcon}
                />
                <Divider variant="middle" />
                <CustomListItem path="#" title="آمار فعالیت" icon={NotifIcon} />
                <Divider variant="middle" />
                <CustomListItem path="#" title="ثبت بار" icon={TermsIcon} />
              </List>
            </nav>
          </Box>
          <Box
            sx={{
              backgroundColor: "background.default",
              // border: "1px solid gray",
              borderRadius: "10px",
              width: "100%",
              maxWidth: 360,
            }}
          >
            <nav
              style={{
                padding: "0px 8px",
              }}
              aria-label="main mailbox folders"
            >
              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <CustomListItem
                  path="/karenclub/courses"
                  title="آموزش ببین و امتیاز بگیر"
                  icon={GuidIcon}
                />
                <CustomListItem
                  path="/guides"
                  title="راهنمای جامع بازارگاه"
                  icon={LearnVideoIcon}
                />
                <CustomListItem path="/terms" title="قوانین" icon={TermsIcon} />
                {/* <CustomListItem path="#" title="آمار فعالیت" icon={NotifIcon} />
                <CustomListItem path="#" title="ثبت بار" icon={TermsIcon} /> */}
              </List>
            </nav>
          </Box>
        </Box>

        {/* <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            padding: "16px",
            width: "100%",
            maxWidth: 360,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img width={20} src={CallIcon} alt="" />
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              شماره تماس مرکز:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
            }}
          >
            07633452480-3
          </Typography>
        </Box> */}
      </SwipeableDrawer>
    </Box>
  );
}
